import 'focus-visible/dist/focus-visible';
import '../static/fonts.css';
import '../static/global.css';
export var onClientEntry = function onClientEntry() {
  // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
  if (!("IntersectionObserver" in window)) {
    // eslint-disable-next-line no-unused-expressions
    // @ts-ignore
    import("intersection-observer");
  }
};
export var onServiceWorkerUpdateReady = function onServiceWorkerUpdateReady() {
  return window.location.reload(true);
};
export var onRouteUpdate = function onRouteUpdate() {
  var pluginOptions = {
    dataLayerName: 'dataLayer',
    includeInDevelopment: true,
    routeChangeEventName: null
  };

  if (process.env.NODE_ENV === "production" || pluginOptions.includeInDevelopment) {
    // wrap inside a timeout to ensure the title has properly been changed
    setTimeout(function () {
      var data = pluginOptions.dataLayerName ? window[pluginOptions.dataLayerName] : window.dataLayer;
      var eventName = pluginOptions.routeChangeEventName ? pluginOptions.routeChangeEventName : "gatsby-route-change";
      data === null || data === void 0 ? void 0 : data.push({
        event: eventName
      });
    }, 50);
  }
};